import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';

import Demo from './Pages/Demo/Demo';
import Layout from './Components/Layout/Layout';
import DemoDetails from './Pages/DemoDetails/DemoDetails';
import Vehicle from './Pages/Vehicle/Vehicle';
import VehicleDetails from './Pages/VehicleDetails/VehicleDetails';
import FossPage from './Pages/FossPage/FossPage';
import PrivacyPage from './Pages/PrivacyPage/PrivacyPage';
import CookiesPage from './Pages/CookiesPage/CookiesPage';
import LandingPage from './Components/LandingPage/LandingPage';
import VimdtLayout from './Components/Vimdt/VimdtLayout';
import ImagesPage from './Pages/Vimdt/ImagesPage';
import EquipmentsPage from './Pages/Vimdt/EquipmentsPage';
import SpecificationPage from './Pages/Vimdt/SpecificationPage';
import ModelsPage from './Pages/Vimdt/ModelsPage';
import './Assets/Styles/_utilities.scss';

function App() {
	const { i18n } = useTranslation();

	useEffect(() => {
		document.documentElement.lang = i18n.language?.split('-')[0] || 'en';
	}, [i18n.language]);

	return (
		<Routes>
			<Route path="" element={<Layout />}>
				<Route path="/home" element={<LandingPage />} />
				<Route path="/demo" element={<Demo />} />
				<Route path="/vehicle/:detailsId" element={<VehicleDetails />} />
				<Route path="/demo/:vehicleId" element={<DemoDetails />} />
				<Route path="/vehicle" element={<Vehicle/>} />
				<Route path="/foss-disclosure" element={<FossPage />} />
				<Route path="/legal/privacy" element={<PrivacyPage />} />
				<Route path="/legal/cookies" element={<CookiesPage />} />

				<Route element={<VimdtLayout />}>
					<Route path="/images" element={<ImagesPage />} />
					<Route path="/equipments" element={<EquipmentsPage />} />
					<Route path="/specification" element={<SpecificationPage />} />
					<Route path="/models" element={<ModelsPage />} />
				</Route>
				<Route path="/download" element={<Navigate to="/images" replace />} />

				<Route path="/" element={<Navigate to="/home" replace />} />
				<Route path="*" element={<Navigate to="/home" replace />} />
			</Route>
		</Routes>
	);
}

export default App;
